import React from 'react';
import whyDidYouRender from '@welldone-software/why-did-you-render';
import { hooks } from 'lib_ui-components';

if (!__PRODUCTION__) {
    whyDidYouRender(React, {
        trackHooks: true,
        trackExtraHooks: [
            [hooks, 'useDbView'],
            [hooks, 'useOrchestrator'],
            [hooks, 'useNavigation']
        ],
        exclude: [
            // These 2 will rerender the same children if the filter changes but
            // created the same result.  There's not an easy way to verify that
            // without comparing every record, so we probably need to rerender
            /AutoSizer/,
            /DropDown/,
            // Need to investigate why these two rerender
            /MenuDrawer/,
            /Collapse/,
            // Rerenders same children when filter boundary context changes
            ///FilterInterdependencyBoundaryProvider/,
            /Swagger/,
            // Seems to be a problem within the third party library
            // @szhsin/react-menu Menu component (or maybe the props we give it?)
            /Menu/
        ]
    });
}

/**
 * FYI - It is often useful to log the prop changes as well.  e.g:

_List.whyDidYouRender = {
    logOnDifferentValues: true
};

Also for components using memo(), you'll need to log the result of memo() instead of what
goes into the function.  e.g:

function List() props { ... }
const _List = memo(List);
_List.displayName = 'MemoizedList';
_List.whyDidYouRender = true;
export default _List;

 */
